var React = require('react');
var Dashboard = require('Dashboard');
var DistributionUnitsManagement = require('DistributionUnitsManagement');
var TransmitterTest = require('TransmitterTest');
var FarmingUnitsManagement = require('FarmingUnitsManagement');
var Settings = require('Settings');
var Account = require('Account');
var Planning = require('Planning');
var Insights = require('../insights/InsightsContainer.jsx');
var Login = require('Login');
var Register = require('Register');
var Confirm = require('Confirm');
var ForgotPassword = require('ForgotPassword');
var IrrigationMonitoring = require('../dashboard/AllFarmView');
var {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} = require('react-router-dom');
var { withSentryRouting } = require('../../sentry');

// Wrap Routes with Sentry for route change tracking
var SentryRoutes = withSentryRouting(Routes);
var { connect } = require('react-redux');
var Header = require('Header');
var LeftSideBar = require('LeftSideBar');
var MainCSS = require('mainCSS');
var reactDatetimeCSS = require('reactDatetimeCSS');
var MapPage = require('MapPage');
var { isMobile } = require('Utils');
var { getItem, setItem } = require('@managers/localStorageManager.jsx');
var CropManagement = require('CropManagement');
var DeleteData = require('DeleteData');
var PrivacyPolicy = require('PrivacyPolicy');
var {
  RemoteConfigurationsContainer,
} = require('../general/RemoteConfigurations/RemoteConfigurationsContainer.jsx');
var { UnicornCelebrationContainer } = require('./UnicornCelebration');
var SupportWidget = require('../support/SupportWidget');
var GlobalSearch = require('./GlobalSearch');
const { useUnitsRecalcObserver } = require('./useUnitsRecalcObserver');
// New Season editors — the pages themselves render nothing (redirect to '/')
// unless the `new_season` remote-configuration flag is on.
const {
  FarmingUnitEditorPage,
  SeasonEditorPage,
} = require('../newSeason/NewSeasonPage');
const {
  FARMING_UNIT_EDITOR_PATH,
  SEASON_EDITOR_PATH,
} = require('../newSeason/newSeasonConstants');

const UnitsRecalcObserver = () => {
  useUnitsRecalcObserver();
  return null;
};

const PrivateRoute = ({ shouldDisplayLogin, element }) => {
  if (shouldDisplayLogin) {
    return <Navigate to='/login' replace />;
  }
  return element;
};

const Main = (props) => {
  const [displayMobileBanner, setDisplayMobileBanner] = React.useState(
    isMobile() && !getItem('HIDE_MOBILE_BANNER'),
  );
  const location = useLocation();
  const navigate = useNavigate();

  const userLoggedIn = () => {
    return props.id_token != null && props.id_token !== '';
  };

  const closeMobileBanner = () => {
    setDisplayMobileBanner(false);
    setItem('HIDE_MOBILE_BANNER', true);
  };

  const pathname = location.pathname;
  const insights_active = pathname.startsWith('/Insights');
  const isFarmView = pathname === '/AllFarmView';
  let headerHeight = 48;
  let seperatorHeight = 1;
  let externalSpaceForMobileBanner = displayMobileBanner ? 40 : 0;

  // if (window.innerWidth < 768) {
  //   headerHeight = 10;
  // }

  let mainScreenStyle = userLoggedIn()
    ? insights_active
      ? {}
      : {
          marginTop:
            (
              headerHeight +
              seperatorHeight +
              externalSpaceForMobileBanner
            ).toString() + 'px',
          height: (100 - headerHeight + seperatorHeight).toString() + 'px',
        }
    : {};

  return (
    <div style={isFarmView ? { overflow: 'hidden', height: '100vh' } : {}}>
      <Header
        shouldDisplayNavigation={userLoggedIn()}
        navigate={navigate}
        location={location}
        headerHeight={headerHeight}
        seperatorHeight={seperatorHeight}
        closeBanner={closeMobileBanner}
        displayMobileBanner={displayMobileBanner}
      />

      {/*<LeftSideBar shouldDisplayNavigation={userLoggedIn()} navigate={navigate} location={location} headerHeight={headerHeight} seperatorHeight={seperatorHeight}/>*/}

      {/* Unicorn celebration overlay - renders on field creation success */}
      <UnicornCelebrationContainer />

      <SupportWidget />
      {/* Cmd/Ctrl + K entity search — global, so it needs no per-screen wiring */}
      {userLoggedIn() ? <GlobalSearch /> : null}
      {userLoggedIn() ? <UnitsRecalcObserver /> : null}

      <div style={mainScreenStyle}>
        <div>
          <SentryRoutes>
            <Route
              path='/'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<Dashboard />}
                />
              }
            />
            <Route
              path='/Planning'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<Planning />}
                />
              }
            />
            <Route
              path='/Insights'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<Insights />}
                />
              }
            />
            <Route
              path='/AllFarmView'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<IrrigationMonitoring />}
                />
              }
            />
            <Route
              path='/Settings'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<Settings />}
                />
              }
            />
            <Route
              path='/Account'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<Account />}
                />
              }
            />
            <Route
              path='/DistributionUnitsManagement'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<DistributionUnitsManagement />}
                />
              }
            />
            <Route
              path='/transmitter-test'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<TransmitterTest />}
                />
              }
            />
            <Route
              path='/FarmingUnitsManagement'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<FarmingUnitsManagement />}
                />
              }
            />
            <Route
              path='/CropManagement'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<CropManagement />}
                />
              }
            />
            <Route
              path='/RemoteConfigurations'
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<RemoteConfigurationsContainer />}
                />
              }
            />
            <Route
              path={
                FARMING_UNIT_EDITOR_PATH + '/:distributionId/:farmingUnitId'
              }
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<FarmingUnitEditorPage />}
                />
              }
            />
            <Route
              path={SEASON_EDITOR_PATH + '/:distributionId/:farmingUnitId'}
              element={
                <PrivateRoute
                  shouldDisplayLogin={!userLoggedIn()}
                  element={<SeasonEditorPage />}
                />
              }
            />
            <Route path='/DeleteData' element={<DeleteData />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/confirm' element={<Confirm />} />
            <Route path='/forgot' element={<ForgotPassword />} />
            <Route path='/map' element={<MapPage />} />
            <Route path='/privacy' element={<PrivacyPolicy />} />
          </SentryRoutes>
        </div>
      </div>
    </div>
  );
};

// export default Main
const mapStateToProps = function (state) {
  return {
    id_token: state.authentication_data.tokens.id_token,
  };
};

module.exports = connect(mapStateToProps)(Main);

/*

<Switch>
  <PrivateRoute exact path="/" component={Dashboard} shouldDisplayLogin={!this.userLoggedIn()}/>
  <PrivateRoute exact path='/Settings' component={Settings} shouldDisplayLogin={!this.userLoggedIn()}/>
  <PrivateRoute exact path='/Account' component={Account} shouldDisplayLogin={!this.userLoggedIn()}/>
  <PrivateRoute exact path='/DistributionUnitsManagement' component={DistributionUnitsManagement} shouldDisplayLogin={!this.userLoggedIn()}/>
  <PrivateRoute exact path='/FarmingUnitsManagement' component={FarmingUnitsManagement} shouldDisplayLogin={!this.userLoggedIn()}/>
  <Route exact path='/login' component={Login}/>
  <Route exact path='/register' component={Register}/>
  <Route exact path='/confirm' component={Confirm}/>
  <Route exact path='/forgot' component={ForgotPassword}/>
  <Route exact path='/map' component={MapPage}/>
</Switch>

*/
